import Vue from 'vue'
import router from './router'
import BeansAdminPlugin, { request, AppLayout, randomFileName } from 'beans-admin-plugin';
import i18n from './i18n-import';
import './theme.scss';

Vue.config.productionTip = false

const uploadToAliyun = async(file, includeRes, uploadOptions = {}) => {
  const { noResize } = uploadOptions;
  const meta = await request.get('aliyun_meta');
  const key = `${meta.dir}${randomFileName(file.name)}`
  const formData = new FormData()
  formData.append('OSSAccessKeyId', meta.access_key_id)
  formData.append('policy', meta.policy)
  formData.append('signature', meta.signature)
  formData.append('success_action_status', 201)
  formData.append('key', key)
  formData.append('file', file)

  const res = await request.post(meta.host, formData, {
    baseURL: '',
    withCredentials: false,
    return_res: true
  })

  let quality = 100
  let url = meta.host + '/' + key
  if (!(file instanceof File) || file.type.startsWith('image')) {
    const fileSize = file.size / 1024; // kb

    if (fileSize < 1000) {
      quality = 100
    } else if (fileSize < 2000) {
      quality = 90;
    } else if (fileSize < 3000) {
      quality = 80;
    } else if (fileSize < 4000) {
      quality = 70;
    } else {
      quality = 60;
    }

    if (noResize) {
      url = url + '?x-oss-process=image';
    } else {
      // w_750 若小于 750 图片不会变化，返回原图
      url = url + '?x-oss-process=image/resize,w_750/quality,q_' + quality;
    }
  }

  if (includeRes) {
    return [url, res];
  }
  return url;
}

const pluginConfig = {
  router,
  config: {
    name: '爱TA小铺',
    logo: require('@/assets/logo.png'),
    request: {
      baseURL: '/admin_api/v1',
      timeout: 60000,
    },
    permission: {
      request_url: '/admin_users/abilities'
    },
    login: {
      request_url: '/sessions',
      navigateTo: { name: 'home' }
    },
    logout: {
      request_url: '/sessions'
    },
    upload: {
      customUpload: uploadToAliyun
    },
  }
}

Vue.use(BeansAdminPlugin, pluginConfig);

const app = new Vue({
  router,
  i18n,
  render: h => h(AppLayout)
}).$mount('#app')

export default app;
